import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAvailableTimeslots } from './actions';
import TimePickerTabs from './TimePickerTabs';
import Spinner from '../Spinner/Spinner';
import { theme } from '../../../../../themes';
import styled from 'styled-components';

const CommontAppointmentTimePicker = styled.div`
  #data-tab {
    .btn-group {
      label {
        height: 60px;
        display: block;
        padding-top: 20px;
        margin: 0 10px 20px 10px;
        border: 1px solid grey;
        border-radius: 5px;
        color: grey;
        &:firstchild {
          margin-left: 15px;
        }
        span {
          display: flex;
          color: #555555a3;
          &:before {
            border-radius: 50%;
            border: 1px solid grey;
            width: 20px;
            height: 20px;
            content: '';
            display: inline-block;
            margin-right: 10px;
          }
        }
        &:hover {
          border-color: ${theme.colors.primaryAccent}; // rectangle around hovered time
        }
        &.active {
          -webkit-box-shadow: none;
          box-shadow: none;
          border-color: ${theme.colors.primaryAccent}; // rectangle around selected time
          span {
            color: ${theme.colors.primaryAccentOnWhite}; // time string

            &:before {
              background: ${theme.colors.primaryAccent}; // radio buton of selected time
              border: 1px solid ${theme.colors.primaryAccent}; // circle around radio buton of selected time
              box-shadow: inset 0px 0px 0px 2px #fff;
            }
          }
        }
      }
    }
  }
`;

class AppointmentTimePicker extends Component {
  componentDidMount() {
    this.props.getAvailableTimeslots(
      this.props.vhtSegment,
      moment()
        .utc()
        .add(15, 'minute')
        .format(),
      this.props.zoneId
    );
  }

  render() {
    var { loading, timeslots, zoneId } = this.props,
      view = null;

    view = <Spinner />;

    if (!loading) {
      view = <TimePickerTabs data={timeslots} zoneId={zoneId} onChange={this.handleTimeSelect.bind(this)} />;
    }

    return <CommontAppointmentTimePicker id="common-appointment-time-picker">{view}</CommontAppointmentTimePicker>;
  }

  handleTimeSelect(event) {
    let { timeslots, onChange } = this.props;

    if (onChange) {
      onChange({
        target: {
          id: this.props.id,
          value: timeslots[event.selectedDate].slots[event.selectedTime],
        },
      });
    }
  }
}

const mapStateToProps = (state) => {
  return {
    timeslots: state.timePicker.timeslots,
    loading: state.timePicker.isFetching,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAvailableTimeslots: getAvailableTimeslots,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentTimePicker);

AppointmentTimePicker.propTypes = {
  zoneId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  getAvailableTimeslots: PropTypes.func,
  timeslots: PropTypes.any,
  loading: PropTypes.bool,
  vhtSegment: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/AppointmentTimePicker.js